import Vue from 'vue';
import Router from 'vue-router';
import Home from './components/views/Home.vue';
import SectionContainer from './components/views/SectionContainer.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    { path: '/', name: 'home', component: Home },
    { path: '/sections/:no', component: SectionContainer, props: true },
    { path: '/feedback', name: 'feedback', component:
      () => import(/* webpackChunkName: "feedback" */ './components/views/Feedback.vue')
    },
    { path: '/cheatsheet', name: 'cheatsheet', component:
      () => import(/* webpackChunkName: "cheatsheet" */ './components/views/CheatSheet.vue')
    },
    { path: '/notices', name: 'notices', component:
      () => import(/* webpackChunkName: "notices" */ './components/views/Notices.vue')
    },
  ]
});